// Using environment variables but maintaining the same exports for backward compatibility
export const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const clubDisplayName = process.env.REACT_APP_CLUB_DISPLAY_NAME;
export const favIconUrl = process.env.REACT_APP_FAVICON_URL;
export const clubWebsiteUrl = process.env.REACT_APP_WEBSITE_URL;
export const clubWebsiteUrlShort = process.env.REACT_APP_WEBSITE_URL_SHORT;
export const clubWebsiteUrlDomainSubstring = process.env.REACT_APP_WEBSITE_DOMAIN;
export const clubFirebaseUrlDomainSubstring = process.env.REACT_APP_FIREBASE_DOMAIN;
export const clubProductionServerUnsubscribe = process.env.REACT_APP_UNSUBSCRIBE_PROD;
export const clubStagingServerUnsubscribe = process.env.REACT_APP_UNSUBSCRIBE_STAGING;
export const clubFacebookUrl = process.env.REACT_APP_FACEBOOK_URL;
export const clubLogo = process.env.REACT_APP_LOGO_URL;

// Helper function to get project-specific images
export const getProjectSpecificImage = (imageName) => {
  try {
    return require(`../images/${projectId}/${imageName}`);
  } catch (error) {
    console.error("Error loading image:", error);
    throw new Error(`Could not find image: ../images/${projectId}/${imageName}. Each project must have its own images.`);
  }
};

// Parse event templates configuration from environment variable
export const parseEventTemplates = () => {
  try {
    if (process.env.REACT_APP_EVENT_TEMPLATES) {
      return JSON.parse(process.env.REACT_APP_EVENT_TEMPLATES);
    }
    return null;
  } catch (error) {
    console.error('Error parsing event templates:', error);
    return null;
  }
};

// Export event templates configuration
export const eventTemplatesConfig = parseEventTemplates();
export const clubFirebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};
export const clubFirebaseConfigTest = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};
export const clubServiceEmail = process.env.REACT_APP_SERVICE_EMAIL;
export const clubDisplayEmail = process.env.REACT_APP_DISPLAY_EMAIL;